export default "__VITE_ASSET__BI1NydPe__"